import React, { Component } from 'react';
import { Popconfirm } from 'antd';
import {
  EditorWrapper, EditorHeader, DashboardFooter, DashboardEditorButton,
  DeleteDashboard, CloseEditorButton,
} from './DashboardEditor.styles';
import { DELETE_DASHBOARD_CONFIRMATION } from '../../constants/text.constants';
import DashboardForm from '../../forms/dashboard';
import Form from '../Form';

class DashboardEditor extends Component {
  // The enableReinitialize prop is assigned for Formik forms so that it can update the value,
  // when context changes or other dashboard tab is selected. Unfortunately, this applies to all
  // cases including changing the dashboard layout which is unwanted and painfully annoying - add
  // Formik does not have a solution to support our use-case.
  //
  // This is solution to address the the problem, that the component needs to be updated according
  // to certain kind of rules.
  shouldComponentUpdate(nextProps) {
    const { dashboard, context, open } = this.props;
    // When opening/closing dashboard, update the editor fields.
    if (open !== nextProps.open) {
      return true;
    }

    // If only changing the dashboard layout, dashboard id doesn't change nor is the week/day
    // context do not update the editor fields.
    if (
      dashboard.pk === nextProps.dashboard.pk
      && context === nextProps.context
    ) {
      return false;
    }

    // Otherwise...update it.
    return true;
  }

  deleteDashboard = () => {
    const { dashboard, deleteDashboard } = this.props;
    deleteDashboard(dashboard.pk);
  }

  updateOrAddDashboard = (dashboardObject, actions) => {
    const { updateDashboard } = this.props;
    updateDashboard(dashboardObject);
    actions.setSubmitting(false); // This is used to reset Formik isSubmitting prop.
  }

  render() {
    const {
      dashboard, dashboards = [], open, toggleEditor, viewLayouts, onChangeLayout, context,
    } = this.props;

    const form = DashboardForm({ context });
    const disableDelete = dashboards.length <= 1;
    const Confirm = props => disableDelete
      ? <p {...props} style={{ marginTop: 12 }} />
      : <Popconfirm {...props} />;

    return open && (
      <EditorWrapper open={open} px="3" py="2" bg="greyscale.6">
        <CloseEditorButton
          color="greyscale.2"
          onClick={toggleEditor}
          fontSize="5"
        />
        <EditorHeader
          fontSize="4"
          color="greyscale.1"
          pb={1}
        >
          {dashboard.name !== '' ? `Edit ${dashboard.name}` : 'Add Dashboard'}
        </EditorHeader>
        <section>
          <Form
            scaffold={form}
            initialValues={dashboard}
            onSubmit={this.updateOrAddDashboard}
            lookupData={{ viewLayouts, context }}
            sideEffectHandler={{ dashboardLayouts: value => onChangeLayout(value) }}
            enableReinitialize
            isSubmitting
            actions={({ submitForm, isSubmitting }) => (
              <DashboardFooter
                width={1}
                color="clientPrimary"
                bg="greyscale.6"
                borderTop="1px solid"
                borderColor="greyscale.3"
                mt={3}
              >
                <section>
                  <DashboardEditorButton
                    type="primary"
                    width={0.3}
                    mr="1"
                    onClick={toggleEditor}
                    disabled={isSubmitting}
                  >
                    Cancel
                  </DashboardEditorButton>
                  <DashboardEditorButton
                    width={0.3}
                    type="primary"
                    ml="1"
                    onClick={submitForm}
                    disabled={isSubmitting}
                  >
                    Save
                  </DashboardEditorButton>
                </section>
                {dashboard && (
                  <Confirm
                    onConfirm={this.deleteDashboard}
                    title={DELETE_DASHBOARD_CONFIRMATION}
                  >
                    <DeleteDashboard
                      m={1}
                      color={disableDelete ? 'greyscale.1' : 'clientPrimary'}
                      disable={disableDelete}
                    >
                      Delete Dashboard
                    </DeleteDashboard>
                  </Confirm>
                )}
              </DashboardFooter>
            )}
          />
        </section>
      </EditorWrapper>
    );
  }
}

export default DashboardEditor;
